import newsletterSubscribe from './subscribe-newsletter';

// Subscribe
new newsletterSubscribe(
    '#form-subscribe-newsletter',
    '#btn-newsletter-signup'
);